import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { guestGuard } from './guards/guest.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/lobby/lobby.page').then((m) => m.LobbyPage),
  },
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    // NOTE: not "themes" — that path collides with the static /themes/ asset directory.
    path: 'theme-picker',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/themes/themes.page').then((m) => m.ThemesPage),
  },
  {
    path: 'game/:matchId',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/game/game.page').then((m) => m.GamePage),
  },
  {
    path: 'review/:matchId',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/review/review.page').then((m) => m.ReviewPage),
  },
  {
    path: 'oauth',
    loadComponent: () => import('./pages/oauth-callback/oauth-callback.page').then((m) => m.OauthCallbackPage),
  },
  { path: '**', redirectTo: '' },
];
